import React, { ComponentType, FC } from 'react';

const HocWithProps = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const WithProps: FC<P> = (props) => <WrappedComponent {...props} />;

  return WithProps;
};

export default HocWithProps;
